import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import { ClipLoader } from "react-spinners";
import swal from "sweetalert";
import AsyncSelect from "react-select/async";
import { connect } from "react-redux";
import * as cpo from "../redux";
import { utils } from "~/utils";

class CMNReportComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false,
            input_circles_value: ""
        };
    }

    loadOptions = val => {
        return this.props.listCircles(val);
    };

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <Formik initialValues={{ circles: "" }} onSubmit={values => this.handleSubmit(values)}>
                            {formik => {
                                return (
                                    <Form>
                                        <div className="form-group">
                                            <label>Circles</label>
                                            <Field
                                                name="circles"
                                                value={formik.values.circles}
                                                component={AsyncSelect}
                                                isClearable
                                                className="basic-multi-select"
                                                isMulti
                                                cacheOptions
                                                defaultOptions
                                                inputValue={this.state.input_circles_value}
                                                loadOptions={this.loadOptions}
                                                onInputChange={val => {
                                                    this.setState({ input_circles_value: val });
                                                    return val;
                                                }}
                                                onChange={val => {
                                                    formik.setFieldValue("circles", val, false);
                                                }}
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-success float-right">
                                            Download
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {
        let request = utils.clearObjectNulls({
            circles: values.circles ? values.circles.map(val => val.value) : null
        });

        const errorMessage = () => {
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        };

        this.setState({ isLoadig: true });

        cpo.service
            .getCMNReport(request)
            .then(_ => this.setState({ isLoadig: false }))
            .catch(_ => {
                this.setState({ isLoadig: false });
                errorMessage();
            });
    };
}

const mapStateToProps = (store, ownProps) => ({});

const mapDispatchToProps = dispatch => ({
    listCircles: search => dispatch(cpo.actions.listCircles(search))
});

export default connect(mapStateToProps, mapDispatchToProps)(CMNReportComponent);
